<div class="modal-header">
  <h1 class="page-title">{{confirmationMessage.title}}</h1>
</div>
<div class="modal-body mt-3">
  <p>{{confirmationMessage.message}}</p>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary" (click)="onNegativeClick();">{{confirmationMessage.negativeBtn}}</button>
  <button class="btn btn-primary" (click)="onPositiveClick();"> {{confirmationMessage.positiveBtn}} </button>
</div>